import {isShippedLabel} from "../../../../services/api/labelApi"

export default async function (id) {
    const {data: response} = await isShippedLabel(id)

    const {success, error} = response

    if (!success) {
        throw new Error(error)
    }

    return true
}
